// Reusable SVG honeybee. `dim` renders a grayed-out bee (used for spent lives).
export default function BeeIcon({ size = 28, dim = false, className = "" }) {
  const bodyDark = dim ? "#9ca3af" : "#1f2937";
  const bodyGold = dim ? "#d1d5db" : "#f59e0b";
  const wing = dim ? "#e5e7eb" : "#bae6fd";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      className={className}
      style={{ opacity: dim ? 0.7 : 1 }}
      aria-hidden="true"
    >
      <defs>
        <clipPath id={`beebody-${dim ? "d" : "n"}`}>
          <ellipse cx="32" cy="40" rx="15" ry="13" />
        </clipPath>
      </defs>
      {/* wings */}
      <ellipse cx="23" cy="26" rx="9" ry="6.5" fill={wing} stroke={bodyDark} strokeWidth="1.2" transform="rotate(-18 23 26)" />
      <ellipse cx="41" cy="26" rx="9" ry="6.5" fill={wing} stroke={bodyDark} strokeWidth="1.2" transform="rotate(18 41 26)" />
      {/* body */}
      <ellipse cx="32" cy="40" rx="15" ry="13" fill={bodyGold} stroke={bodyDark} strokeWidth="2" />
      {/* stripes */}
      <g clipPath={`url(#beebody-${dim ? "d" : "n"})`}>
        <rect x="17" y="31" width="30" height="5" fill={bodyDark} />
        <rect x="17" y="41" width="30" height="5" fill={bodyDark} />
        <rect x="17" y="51" width="30" height="5" fill={bodyDark} />
      </g>
      {/* stinger */}
      <path d="M32 53 l-3 5 h6 z" fill={bodyDark} />
      {/* head */}
      <circle cx="32" cy="20" r="8" fill={bodyDark} />
      {/* eyes */}
      <circle cx="29" cy="19" r="1.6" fill="#fff" />
      <circle cx="35" cy="19" r="1.6" fill="#fff" />
      {/* antennae */}
      <path d="M28 14 q-4 -6 -7 -6" fill="none" stroke={bodyDark} strokeWidth="1.6" strokeLinecap="round" />
      <path d="M36 14 q4 -6 7 -6" fill="none" stroke={bodyDark} strokeWidth="1.6" strokeLinecap="round" />
      <circle cx="21" cy="8" r="1.8" fill={bodyDark} />
      <circle cx="43" cy="8" r="1.8" fill={bodyDark} />
    </svg>
  );
}
